import { forwardRef, Fragment, memo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./SearchEngineStepLabel.scss";
import IconClockNotification from "app/pages/.shared/static/icons/IconClockNotification";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const SearchEngineStepLabel = forwardRef(
	({ isComplete, className, defaultLabel, label, onClick, stressMarketingLabel }, ref) => {
		return (
			<>
				<div
					ref={ref}
					onClick={onClick}
					className={classNames("search-engine-step-label", className)}
				>
					{isComplete ? (
						<Fragment>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.LARGE}
								isBold
								className="search-engine-step-label__label"
							>
								{label}
							</Typography>
							<div className="search-engine-step-label__edit">
								<FormattedMessage id="search.engine.edit.label" />
							</div>
						</Fragment>
					) : (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.LARGE}
							isBold
							className="search-engine-step-label__label"
						>
							{defaultLabel}
						</Typography>
					)}
				</div>

				{stressMarketingLabel && isComplete && (
					<div className="search-engine-step-stress-marketing__msg">
						<div className="search-engine-step-stress-marketing__msg-icon">
							<IconClockNotification width={16} heigth={16} />
						</div>
						<div className="search-engine-step-stress-marketing__msg-label">
							{stressMarketingLabel}
						</div>
					</div>
				)}
			</>
		);
	}
);

SearchEngineStepLabel.propTypes = {
	isComplete: PropTypes.bool,
	defaultLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	className: PropTypes.string,
	onClick: PropTypes.func,
	stressMarketingLabel: PropTypes.string,
};

export default memo(SearchEngineStepLabel);
